import { graphql, useStaticQuery } from 'gatsby';

/**
 * Fetch news banner and popup entries.
 *
 * @returns {{ allNewsBanners: allContentfulComponentNewsBanner, popup: contentfulComponentPopup }}
 */
function useHeaderStaticQuery() {
  const { allNewsBanners, popup } = useStaticQuery(graphql`
    query MuiHeaderStaticQuery {
      allNewsBanners: allContentfulComponentNewsBanner {
        nodes {
          id
          text {
            markdown: childMarkdownRemark {
              html
            }
          }
          link {
            title
            url
          }
          backgroundColor
          textColor
          pagesWithBanner {
            __typename
            ... on Node {
              ... on ContentfulGlobalPage {
                id
                slug
              }
              ... on ContentfulGlobalBlog {
                id
                slug
              }
              ... on ContentfulGlobalPost {
                id
                slug
              }
            }
          }
          campaignName
          masterHideBanner
          impress
          BFstyles
          gradientBackgroundOption
        }
      }
      popup: contentfulComponentPopup {
        deactivateInAllPages
        isNewVersion
        text
        headline
        closeSentence
        button {
          url
          title
        }
        image {
          localFile {
            childImageSharp {
              gatsbyImageData(width: 800, quality: 60, layout: CONSTRAINED)
            }
          }
        }
        isMergeVersion
        leadText {
          raw
        }
        pagesToAvoidPopup {
          __typename
          ... on Node {
            ... on ContentfulGlobalPage {
              slug
            }
            ... on ContentfulGlobalBlog {
              slug
            }
            ... on ContentfulGlobalPost {
              slug
            }
            ... on ContentfulGlobalSurvey2 {
              slug
            }
            ... on ContentfulGlobalBookingV2 {
              slug
            }
          }
        }
      }
    }
  `);

  return { allNewsBanners: allNewsBanners.nodes, popup };
}

export default useHeaderStaticQuery;
